"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGGroup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function SVGGroup(props) {
    const elementsRefs = (0, react_1.useRef)([]);
    const { children, direction = 'row', space = 0, ...resProps } = props;
    (0, react_1.useLayoutEffect)(() => {
        let shift = 0;
        if (elementsRefs) {
            for (const element of elementsRefs.current) {
                if (element) {
                    const boundary = element.getBoundingClientRect();
                    if (direction === 'row') {
                        element.style.transform = `translate(${shift}px,0)`;
                        shift += boundary.width + space;
                    }
                    else {
                        element.style.transform = `translate(0,${shift}px)`;
                        shift += boundary.height + space;
                    }
                }
            }
        }
    });
    const items = react_1.Children.toArray(children);
    return ((0, jsx_runtime_1.jsx)("g", { ...resProps, children: react_1.Children.map(items, (child, index) => {
            return ((0, jsx_runtime_1.jsx)("g", { ref: (ref) => {
                    if (ref) {
                        elementsRefs.current[index] = ref;
                    }
                }, children: child }, child?.key || `${index}`));
        }) }));
}
exports.SVGGroup = SVGGroup;
